import { observable } from 'mobx';

export type KitElementResponseArgs = {
  id: number;
  name: string;
};

export type KitElementArgs = {
  id: number;
  name: string;
};

export const convertKitElementResponseToArgs = (response: KitElementResponseArgs) => {
  const args: KitElementArgs = {
    id: response.id,
    name: response.name
  };
  return args;
};

export default class KitElement {
  @observable
  id: number;

  @observable
  name: string;

  constructor(args: KitElementArgs) {
    this.id = args.id;
    this.name = args.name;
  }

  get type() {
    return 'kit';
  }

  get title() {
    return '新型コロナ検査キット';
  }

  get summary() {
    return '[新型コロナ検査キット]';
  }

  detail() {
    return '';
  }
}
